import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const WhoWeAre = () => {
    const { ref, inView } = useInView({
        triggerOnce: true, // only trigger once
        threshold: 0.3, // triggers when 30% of section is visible
    });

    return (
        <section ref={ref} className="w-full py-16 bg-white">
            {/* Section Title */}
            <div className="text-center px-4">
                <motion.h2
                    className="text-3xl sm:text-4xl font-bold text-[#E43038]"
                    initial={{ opacity: 0, y: -20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    Who We Are ?
                </motion.h2>

                <motion.p
                    className="text-xl sm:text-2xl text-[#012D6F] mt-2 font-semibold"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    Where Passion Meets Precision
                </motion.p>
            </div>

            {/* Content Section */}
            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 items-center px-6 md:px-12 lg:px-20">
                {/* Left Content */}
                <motion.div
                    className="space-y-6"
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                        At{" "}
                        <span className="font-semibold text-[#012D6F]">
                            4 Aviators Aviation Academy
                        </span>
                        , we are dedicated to shaping the next generation of skilled,
                        professional pilots. Our mission is to provide world-class flight
                        training that combines cutting-edge technology, experienced
                        instructors, and an unwavering commitment to safety. Whether you're
                        pursuing your dream of becoming a commercial pilot or looking to
                        earn your private pilot license, we offer comprehensive programs
                        tailored to your goals. With our modern fleet and state-of-the-art
                        facilities, you'll receive the highest quality education in
                        aviation.
                    </p>

                    {/* Counters */}
                    <div className="flex flex-wrap gap-6 sm:gap-10 mt-6">
                        <div className="text-center">
                            <h3 className="text-4xl font-bold text-[#E43038]">
                                {inView ? <CountUp end={15} duration={2} /> : "0"}+
                            </h3>
                            <p className="text-gray-700 mt-1 text-sm sm:text-base">
                                Years Experience
                            </p>
                        </div>

                        <div className="text-center">
                            <h3 className="text-4xl font-bold text-[#E43038]">
                                {inView ? <CountUp end={500} duration={2} /> : "0"}+
                            </h3>
                            <p className="text-gray-700 mt-1 text-sm sm:text-base">
                                Certified Pilots
                            </p>
                        </div>

                        <div className="text-center">
                            <h3 className="text-4xl font-bold text-[#E43038]">
                                {inView ? <CountUp end={100} duration={2} /> : "0"}%
                            </h3>
                            <p className="text-gray-700 mt-1 text-sm sm:text-base">
                                Safety Record
                            </p>
                        </div>
                    </div>
                </motion.div>

                {/* Right Image */}
                <motion.div
                    className="flex justify-center md:justify-end"
                    initial={{
                        opacity: 0,
                        clipPath: "polygon(0% 50%, 100% 50%, 100% 50%, 0% 50%)", // collapsed center line horizontally
                    }}
                    whileInView={{
                        opacity: 1,
                        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", // expands top & bottom
                    }}
                    transition={{
                        duration: 0.5,
                        ease: "easeInOut",
                    }}
                    viewport={{ once: true }}
                >
                    <img
                        src="https://mhcockpit.com/Media/4%20Aviators/Home/who-we-are.jpg"
                        alt="Who We Are"
                        className="w-full max-w-md rounded-2xl shadow-lg object-cover"
                    />
                </motion.div>

            </div>
        </section>
    );
};

export default WhoWeAre;
